import { useIndexedDBRestQuery } from '@repo/services';
import { type TenantInfoType } from '@repo/utils';
import { CaseUtil } from '@vectord/utils';

export const TENANT_INFO_ENDPOINT = '/v1/tenants/info';
export const TENANT_INFO_CACHE_KEY = 'tenant-info';

export const useFetchTenantInfo = ({ skip = false }: { skip?: boolean } = {}) => {
  const {
    data: tenantInfoData,
    isLoading,
    error,
  } = useIndexedDBRestQuery<TenantInfoType, TenantInfoType>({
    endpoint: TENANT_INFO_ENDPOINT,
    method: 'GET',
    cacheKey: TENANT_INFO_CACHE_KEY,
    transform: (data: any) => CaseUtil.toCase('camelCase', data),
    skip,
    // Stale-while-revalidate: cached branding renders instantly while a fresh
    // request runs in the background. The previous lazy variant only fetched on
    // a cache miss, so once the cache was warm (now as early as the pre-auth
    // /login fetch) the tenant-info API was never called again and backend
    // branding changes never reached users who had already loaded the app.
    revalidate: true,
  });

  return {
    tenantInfoData,
    isLoading,
    error,
  };
};
